import React from "react";
import styled from "styled-components";

import * as Layout from "~/Layout";
import { NotApplicable } from "~/NotApplicable";
import * as Typography from "~/Typography";

export function Statistic({
  Title = () => null,
  Value = () => <NotApplicable />,
  ...props
}: Statistic.Props) {
  return (
    <Statistic.Container>
      <Statistic.Value {...props}>
        <span>
          <Value />
        </span>
      </Statistic.Value>
      <Statistic.Title {...props}>
        <span>
          <Title />
        </span>
      </Statistic.Title>
    </Statistic.Container>
  );
}

export namespace Statistic {
  export type Props = {
    readonly Title: Component;
    readonly Value?: Component;
    readonly danger?: boolean;
    readonly small?: boolean;
  };

  const minimumFontSize = () => "1em" as const;
  const minimumStatisticFontSize = () => "1.2em" as const;
  const fontSize = () => ({ scaled: "2vw" as const, max: "3.5em" as const });
  const fontSizeSmall = () => ({
    scaled: "1.75vw" as const,
    max: "1.8em" as const,
  });

  export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  `;

  export const Value = styled.div<Pick<Props, "small">>`
    padding-bottom: ${Layout.Inline.padding};

    & > span {
      font-weight: 300;
      font-size: max(
        min(
          ${({ small }) =>
            small ? fontSizeSmall().scaled : fontSize().scaled},
          ${({ small }) => (small ? fontSizeSmall().max : fontSize().max)}
        ),
        ${minimumStatisticFontSize()}
      );

      /* TODO: Remove conflict. */
      line-height: 1em;
    }
  `;

  const titleFontSize = () => ({
    scaled: ".984vw" as const,
    max: Typography.H3.fontSize(),
  });
  const titleFontSizeSmall = () => ({
    scaled: ".9vw" as const,
    max: Typography.H4.fontSize(),
  });

  export const Title = styled.div<Pick<Props, "small">>`
    font-size: max(
      min(
        ${({ small }) =>
          small ? titleFontSizeSmall().scaled : titleFontSize().scaled},
        ${({ small }) =>
          small ? titleFontSizeSmall().max : titleFontSize().max}
      ),
      ${minimumFontSize()}
    );
  `;
}
